import React, { useState, useEffect, useRef } from 'react';
import { FaTrophy, FaUsers, FaRocket, FaClock } from 'react-icons/fa';
import '../../../../assets/css/user/general/counter/Counter.css';

const Counter = () => {
  const [counters, setCounters] = useState({
    awards: 0,
    clients: 0,
    projects: 0,
    upTime: 0
  });

  const sectionRef = useRef(null);
  const hasCountedRef = useRef(false); // ⚡ useRef to persist across renders without re-trigger

  const targets = { awards: 15, clients: 1024, projects: 1024, upTime: 99 };
  const duration = 2000;
  const steps = 60;
  const interval = duration / steps;

  const animateCount = () => {
    let step = 0;
    const timer = setInterval(() => {
      step++;
      setCounters({
        awards: Math.floor((targets.awards / steps) * step),
        clients: Math.floor((targets.clients / steps) * step),
        projects: Math.floor((targets.projects / steps) * step),
        upTime: Math.floor((targets.upTime / steps) * step)
      });

      if (step >= steps) {
        clearInterval(timer);
        setCounters(targets);
      }
    }, interval);
  };

  useEffect(() => {
    const observer = new IntersectionObserver(
      ([entry], observerInstance) => {
        if (entry.isIntersecting && !hasCountedRef.current) {
          animateCount();
          hasCountedRef.current = true; // mark counted
          observerInstance.unobserve(entry.target); // stop observing after first trigger
        }
      },
      { threshold: 0.5 }
    );

    if (sectionRef.current) {
      observer.observe(sectionRef.current);
    }

    return () => {
      if (sectionRef.current) observer.unobserve(sectionRef.current);
    };
  }, []);

  return (
    <section className="counter-section" ref={sectionRef}>
      <div className="counter-overlay"></div>
      <div className="container">
        <div className="row text-center">
          <div className="col-md-3 col-sm-6 mb-4">
            <div className="counter-item">
              <FaTrophy className="counter-icon" />
              <h3 className="counter-number">{counters.awards}</h3>
              <p className="counter-label">Awards</p>
            </div>
          </div>

          <div className="col-md-3 col-sm-6 mb-4">
            <div className="counter-item">
              <FaUsers className="counter-icon" />
              <h3 className="counter-number">{counters.clients}</h3>
              <p className="counter-label">Happy Clients</p>
            </div>
          </div>

          <div className="col-md-3 col-sm-6 mb-4">
            <div className="counter-item">
              <FaRocket className="counter-icon" />
              <h3 className="counter-number">{counters.projects}</h3>
              <p className="counter-label">Projects</p>
            </div>
          </div>

          <div className="col-md-3 col-sm-6 mb-4">
            <div className="counter-item">
              <FaClock className="counter-icon" />
              <h3 className="counter-number">{counters.upTime}%</h3>
              <p className="counter-label">Up Time</p>
            </div>
          </div>
        </div>
      </div>

      <link
        href="https://cdn.jsdelivr.net/npm/bootstrap@5.3.0/dist/css/bootstrap.min.css"
        rel="stylesheet"
      />
    </section>
  );
};

export default Counter;
